export enum Limb {
    Face = 'face',
    HandsInside = 'hands-inside',
    HandsOutside = 'hands-outside',
    Torso = 'torso',
    FeetBottom = 'feet-bottom',
    FeetTop = 'feet-top'
}
